import { Plug, Ruler, Undo2 } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const cards = [
  {
    icon: Plug,
    title: "No machine to rent",
    body: "A cordless drill drives every fastener in the system. Nothing else plugs in, nothing gets hauled out to the fence line.",
  },
  {
    icon: Ruler,
    title: "No skill to learn",
    body: "Line the bracket up, run the screws, set the rail. If you can hang a shelf square, you can set a rail square.",
  },
  {
    icon: Undo2,
    title: "Comes back apart",
    body: "Screws back out. A weld does not. Reset a rail, pull a section to get equipment through, change your mind.",
  },
];

export const Problem = () => (
  <section className="section" data-testid="problem-section">
    <div className="wrap">
      <SectionHead
        num="01"
        eyebrow="The problem it solves"
        title="Welding is the reason most people never build their own metal fence."
        lede="Pipe and tube fence is what a lot of people want on their place. The catch has always been the same: every joint has to be welded. That means a machine, the skill to run it, and power out where the fence is going."
      />
      <div className="trio">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}>
            <div className="card" data-testid={`problem-card-${i + 1}`}>
              <div className="card-ico">
                <c.icon size={22} aria-hidden="true" />
              </div>
              <h3>{c.title}</h3>
              <p>{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
